<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易管理</el-breadcrumb-item>
      <el-breadcrumb-item>天使服海神套预定</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-input v-model.trim="queryField.orderId" size="small" placeholder="订单id"></el-input>
        <el-input v-model.trim="queryField.userId" size="small" placeholder="用户id"></el-input>
        <el-input v-model.trim="queryField.userName" size="small" placeholder="玩家账号"></el-input>
        <el-input v-model.trim="queryField.roleName" size="small" placeholder="收货游戏角色" />
        <el-input v-model.trim="queryField.serverName" size="small" placeholder="收货游戏区服" />
        <el-select v-model="queryField.status" size="small" placeholder="订单状态">
          <el-option label="订单状态" value=""/>
          <el-option label="已下单" value="0"/>
          <el-option label="已付定金" value="1"/>
          <el-option label="已付款" value="2"/>
          <el-option label="已完成" value="3"/>
          <el-option label="已撤销" value="4"/>
        </el-select>
        <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </el-row>

      <el-table class="cps-table-data"
                :data="tableData" size="small"
                border
                :height="height"
                style="width: 100%">
        <el-table-column
            prop="order_id"
            label="订单id"
            width="60">
        </el-table-column>
        <el-table-column
            prop="user_id"
            label="用户id"
            width="90">
        </el-table-column>
        <el-table-column
            prop="user_name"
            label="玩家账号"
            width="120">
        </el-table-column>
        <!--<el-table-column
            prop="game_name"
            label="游戏名"
            width="120">
        </el-table-column>-->
        <el-table-column
            prop="role_name"
            label="收货角色名"
            width="120">
        </el-table-column>
        <el-table-column
            prop="server_name"
            label="收货角色区服"
            width="120">
        </el-table-column>
        <el-table-column
            prop="num"
            label="预定数量(件)"
            width="100">
        </el-table-column>
        <el-table-column
                prop="price"
                label="每件单价"
                width="100">
        </el-table-column>
        <el-table-column
                prop="total_amount"
                label="总价格"
                width="100">
        </el-table-column>
        <el-table-column
                prop="advance_amount"
                label="预付定金"
                width="100">
        </el-table-column>
        <el-table-column
                prop="balance_amount"
                label="尾款"
                width="100">
        </el-table-column>

        <el-table-column
            prop="wx"
            label="微信号"
            width="100">
        </el-table-column>
        <el-table-column
            prop="qq"
            label="qq号"
            width="100">
        </el-table-column>
        <el-table-column
            prop="tel"
            label="手机号"
            width="120">
        </el-table-column>
        <el-table-column
            prop="status"
            label="订单状态"
            :formatter="orderStatusFormat"
            width="80">
        </el-table-column>
        <el-table-column
            label="操作"
            v-if="showOperate">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.status === 0 && showDeposit" @click="advanceDeposit(scope.row.order_id)">已付定金</el-button>
            <el-button type="text" size="small" v-if="scope.row.status === 1 && showPayment" @click="completePay(scope.row.order_id)">已付款</el-button>
            <el-button type="text" size="small" v-if="scope.row.status === 2 && showComplete" @click="haveCompleted(scope.row.order_id)">已完成</el-button>
            <el-button type="text" size="small" v-if="scope.row.status < 3 && showRevocation" @click="revocation(scope.row.order_id)">撤销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="15"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryHstOrder, payDeposit, accountPaid, alreadyComplete, doRevocation, getPageButtons} from "@/api/request";
export default {
  name: "transactionHstOrder",
  data(){
    return {
      queryField:{
        orderId: '',
        userId: '',
        userName: '',
        roleName: '',
        serverName: '',
        status: '',
      },
      tableData:[],
      total: 0,
      height: window.innerHeight - 220,
      currentIndex: 1,
      showOperate: false,
      showQuery: false,
      showDeposit: false,
      showPayment: false,
      showComplete: false,
      showRevocation: false
    }
  },
  mounted() {
    this.loadData(1);
    this.getPageButtons();
  },
  methods:{
    loadData(index){
      let params = {
        pageNo: 1,
        pageSize: 15,
        params: this.queryField
      }
      queryHstOrder(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
      })
    },
    advanceDeposit(orderId){ //已付定金
      this.$confirm('确认订单已付定金吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        payDeposit(orderId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    completePay(orderId){ //已付款
      this.$confirm('确认订单已付款吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        accountPaid(orderId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    haveCompleted(orderId){
      this.$confirm('确认订单已完成吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        alreadyComplete(orderId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    revocation(orderId){
      this.$confirm('确认要撤销该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doRevocation(orderId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功");
            this.loadData(this.currentIndex);
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    getPageButtons() {
      let path = this.$route.path.replace("/", "");
      getPageButtons(path).then((res) => {
        if (res.data.success) {
          let menuCodes = res.data.data;
          this.showDeposit = menuCodes.includes("hstOrder_deposit");
          this.showPayment = menuCodes.includes("hstOrder_payment");
          this.showComplete = menuCodes.includes("hstOrder_complete");
          this.showRevocation = menuCodes.includes("hstOrder_revocation");
          this.showOperate = this.showDeposit || this.showPayment || this.showComplete || this.showRevocation;
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    reset(){
      this.queryField = {
        orderId: '',
        userId: '',
        userName: '',
        roleName: '',
        serverName: '',
        status: '',
      }
    },
    orderStatusFormat(row, column, cellValue){  //0：已下单 1:已付定金 2:已付款 3：已完成  4：已撤销
      let str = '';
      if(cellValue === 0){
        str = '已下单';
      }else if (cellValue === 1){
        str = '已付定金';
      }else if(cellValue === 2){
        str = '已付款';
      }else if(cellValue === 3){
        str = '已完成';
      }else if(cellValue === 4){
        str = '已撤销';
      }
      return str;
    },
  }
}
</script>

<style scoped>

</style>